<template>
  <div class="settings">
    <h1 class="center">{{$t('settings')}}</h1>
    <div class="wrapper">
      <a-tabs
        :defaultActiveKey="activeKey"
        defaultActive="activeKey"
        @change="onTabChange"
        size="large"
        type="card"
      >
        <a-tab-pane key="1">
          <template v-slot:tab>
            <span class="ant-badge ant-badge-status">
              <span>{{$t('categories')}}</span>
              <sup
                v-if="!!user && !user.hasConfigured.categories"
                class="ant-scroll-number ant-badge-dot ant-badge-status-default"
              ></sup>
            </span>
          </template>
        </a-tab-pane>
        <a-tab-pane key="2">
          <template v-slot:tab>
            <span class="ant-badge ant-badge-status">
              <span>{{$t('currencies')}}</span>
              <sup
                v-if="!!user && !user.hasConfigured.currencies"
                class="ant-scroll-number ant-badge-dot ant-badge-status-default"
              ></sup>
            </span>
          </template>
        </a-tab-pane>
        <a-tab-pane key="3">
          <template v-slot:tab>
            <span class="ant-badge ant-badge-status">
              <span>{{$t('tags')}}</span>
              <sup
                v-if="!!user && !user.hasConfigured.tags"
                class="ant-scroll-number ant-badge-dot ant-badge-status-default"
              ></sup>
            </span>
          </template>
        </a-tab-pane>
      </a-tabs>
      <categories v-if="activeKey === '1'"></categories>
      <currencies v-else-if="activeKey === '2'"></currencies>
      <Tags v-else-if="activeKey === '3'"></Tags>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { USER_INFO } from "../store/constants";
export default {
  name: "settings",
  computed: {
    ...mapState({
      user: state => state.auth[USER_INFO]
    })
  },
  components: {
    Categories: () => import("../components/Categories.vue"),
    Currencies: () => import("../components/Currencies.vue"),
    Tags: () => import("../components/Tags.vue")
  },
  data() {
    return { activeKey: "1" };
  },
  // watch: {
  //   user(newV, oldV) {
  //     if (newV && !oldV) {
  //       // console.log(this.user, newV);
  //     }
  //   }
  // },
  methods: {
    onTabChange(key) {
      this.activeKey = key;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../styles/variables.less";

.wrapper {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  > .ant-tabs-card {
    position: relative;
    z-index: 2;
    margin-bottom: 16px;
    > .ant-tabs-content {
      height: 120px;
      margin-top: -16px;
    }
    > .ant-tabs-content > .ant-tabs-tabpane {
      background: #fff;
    }
    > .ant-tabs-bar {
      border-color: #fff;
    }
    > .ant-tabs-bar .ant-tabs-tab {
      border-color: transparent;
      background: transparent;
    }
    > .ant-tabs-bar .ant-tabs-tab-active {
      border-color: #fff;
      background: #fbf4fb;
    }
  }
}
</style>
